import React from "react";
import { Modal, Button } from "react-bootstrap";

const SuccessModal = ({ show, onClose }) => (
    <Modal show={show} onHide={onClose}>
        <Modal.Header closeButton>
            <Modal.Title>Transaction Successful</Modal.Title>
        </Modal.Header>
        <Modal.Body>Your coins will be credited to your wallet within 5 hours.</Modal.Body>
        <Modal.Footer>
            <Button variant="primary" onClick={onClose}>
                Close
            </Button>
        </Modal.Footer>
    </Modal>
);

export default SuccessModal;
